// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__34QPa","empty":"ModalGraph_empty__2JNJm"};